import { clsx } from 'clsx';
import * as React from 'react';

import styles from './MobileBottomContainer.css';
import { useScrollDirection } from './hooks';

export const MobileBottomContainer: React.FC<React.PropsWithChildren> = ({ children }) => {
  const scrollDirection = useScrollDirection();

  return (
    <div className={clsx(styles['bottom-container'], scrollDirection === 'down' && styles['bottom-container--hidden'])}>
      {children}
    </div>
  );
};
